<template>
  <div class="empty-section">
    <img v-if="showImg" :src="imgSrcToUse" alt="empty" class="empty-img" />
    <div class="empty-tip">
      <slot>{{ tip }}</slot>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed } from "vue";
import { getGameConfig } from "@/config/gameConfig";
import { useLanguageStore } from "@/stores";
const languageStore = useLanguageStore();
const props = defineProps({
  imgSrc: {
    type: String,
    default: "",
  },
  tip: {
    type: String,
    default: "",
  },
  showImg: {
    type: Boolean,
    default: true,
  },
});
const gameConfig = getGameConfig();
const defaultImg = computed(
  () => languageStore.getImage("iconEmpty") || gameConfig.iconEmpty
);
const imgSrcToUse = computed(() => props.imgSrc || defaultImg.value);
</script>

<style scoped>
.empty-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}
.empty-img {
  width: 150px;
  height: 150px;
  object-fit: contain;
}
.empty-tip {
  font-size: 12px;
  color: #ccc;
}
</style>
